import { render, staticRenderFns } from "./ThreadEnvelope.vue?vue&type=template&id=056e4106&scoped=true"
import script from "./ThreadEnvelope.vue?vue&type=script&lang=js"
export * from "./ThreadEnvelope.vue?vue&type=script&lang=js"
import style0 from "./ThreadEnvelope.vue?vue&type=style&index=0&id=056e4106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e4106",
  null
  
)

export default component.exports